
export function selectedLang() {
    let language = localStorage.getItem('healthcare_lang');
    if(language){
        return language
    }else{
        return 'en'
    }
}